import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResortComponent } from './resort.component';
import { ImgHeaderModule } from '../../img-header/img-header.module';
import { SharedModule } from '../../shared/shared.module';
import { QuoteModule } from '../../quote/quote.module';

@NgModule({
  imports: [
    CommonModule,
    ImgHeaderModule,
    SharedModule,
    QuoteModule
  ],
  declarations: [
    ResortComponent
  ]
})
export class ResortModule { }



// WEBPACK FOOTER //
// ./src/app/pages/resort/resort.module.ts